module.exports = __webpack_public_path__ + "f30367158f15986e71233aa5b4d48d00.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_medium_x1/public/history/7.jpg
// module id = 295
// module chunks = 0